import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ProductListEffects } from '@b2b/features/product/core/store/effects/product-list.effect';
import { ProductEffects } from '@b2b/features/product/core/store/effects/product.effect';
import { productListReducer } from '@b2b/features/product/core/store/reducers/product-list.reducer';
import { productReducer } from '@b2b/features/product/core/store/reducers/product.reducer';
import { PRODUCT_LIST_FEATURE } from '@b2b/features/product/core/store/selectors/product-list.selectors';
import { PRODUCT_FEATURE } from '@b2b/features/product/core/store/selectors/product.selectors';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(PRODUCT_LIST_FEATURE, productListReducer),
    StoreModule.forFeature(PRODUCT_FEATURE, productReducer),
    EffectsModule.forFeature([ProductListEffects, ProductEffects]),
  ],
})
export class ProductStoreModule {}
